import { createContext, Suspense, useEffect, useState } from 'react';

import { NotificationProvider } from 'providers/NotificationProvider';

import { ExperimentationProvider } from 'libs/Eppo';

import ScrollToTopButton from 'components/ScrollToTopButton';
import { useScrollToTopConfig } from 'components/ScrollToTopButton/hooks/useScrollToTopConfig';

import { Box, useMediaQuery, useTheme } from '@mui/material';

import Drawer from './Drawer';
import Header from './Header';
import Main from './Main';

export const MenuContext = createContext<{
    isDrawerOpen: boolean;
    openItem: string | null;
    setOpenItem: (id: string | null) => void;
}>({
    isDrawerOpen: false,
    openItem: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setOpenItem: () => {},
});

const MainLayout = () => {
    const theme = useTheme();
    const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'));
    const { isEnabled: isScrollToTopEnabled } = useScrollToTopConfig();

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [openItem, setOpenItem] = useState<string | null>('dashboard');
    const handleDrawerToggle = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    useEffect(() => {
        setIsDrawerOpen(!matchDownLG);
    }, [matchDownLG]);

    return (
        <Suspense>
            <ExperimentationProvider>
                <MenuContext.Provider value={{ isDrawerOpen, openItem, setOpenItem }}>
                    <NotificationProvider>
                        <Box sx={{ display: 'flex', width: '100%' }}>
                            <Header open={isDrawerOpen} handleDrawerToggle={handleDrawerToggle} />
                            <Drawer open={isDrawerOpen} handleDrawerToggle={handleDrawerToggle} />
                            <Main />
                        </Box>
                        {isScrollToTopEnabled && <ScrollToTopButton data-locator="scrollToTopButton" />}
                    </NotificationProvider>
                </MenuContext.Provider>
            </ExperimentationProvider>
        </Suspense>
    );
};

export default MainLayout;
